import { h } from '@stencil/core';
import { FlightSegmentDto } from 'client/types';
import BaggageDetail from './BaggageDetail';
import AirlineInfo from './AirlineInfo';
import SegmentInfo from './SegmentInfo';
import SegmentConnection from './SegmentConnection';
import { i18n } from 'i18n';

export default function FlightTab({ flightSegment }: { flightSegment: FlightSegmentDto }) {
  return (
    <div class="tab-inner-content">
      {flightSegment.detailedSegments.map(segment => {
        return (
          <div class="segment-container">
            <div class="eva-3-card -eva-3-shadow-line item-detail-content">
              <AirlineInfo airlineCode={segment.airline} flightId={segment.flightId} planeModel={segment.aircraft} cabinType={segment.cabinType} />
              <SegmentInfo segment={segment} />
            </div>
            <SegmentConnection
              time={segment.waitTime || flightSegment.duration}
              city={segment.destination.name}
              lastStop={typeof segment.waitTime === 'undefined'}
              planeChange={segment.changePlane}
            />
          </div>
        );
      })}

      <span class="local-hour -eva-3-mb-md"> {i18n.t.flightDetailModal.localTime} </span>
      <BaggageDetail bags={flightSegment.bags} />
    </div>
  );
}
